import { CardsTableRow } from './CardsTableRow';
export default CardsTableRow;
